import { useCallback } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import FilterPanelCheckboxGroup, { type FilterPanelCheckItem } from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'

interface Props {
  items: Array<FilterPanelCheckItem>
  onFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  selectedItems: Set<string>
  onOnlySelect?: (value: string) => void
}

function FlightSingleFilterAirlines(props: Props) {
  const { items, onFilterChange, selectedItems, onOnlySelect } = props
  const intl = useIntl()

  const selectAllLabel = intl.formatMessage({
    id: 'Eqn26n13o8T6tWk-yiIG',
    defaultMessage: 'Select all airlines',
    description: 'Toggle label to select every airline option in the flights filter panel',
  })

  const handleOnlyClick = useCallback((value: string | number) => {
    onOnlySelect?.(value.toString())
  }, [onOnlySelect])

  return (
    <FilterPanelCheckboxGroup
      name="airlines"
      items={items}
      onChange={onFilterChange}
      selected={selectedItems}
      maxItems={5}
      density="compact"
      selectAllMode="switch"
      selectAllLabel={selectAllLabel}
      showMoreWithCount
      showOnly
      onOnlyClick={handleOnlyClick}
      highlightLowestPrice
    />
  )
}

export default FlightSingleFilterAirlines
